/**
 * Field Edition tokens for the co-op PDF.
 * Matches yona-web src/styles/tokens.css (--y-*).
 * Built-in PDF fonts stand in for Bevan / Work Sans / Space Mono
 * (react-pdf needs bundled TTF to use those families).
 */
export const PLANTING_PDF_ENAMEL = Object.freeze({
  ink: '#221E18',
  inkSoft: '#4A4237',
  mute: '#6B6350',
  paper: '#F0EADA',
  paper2: '#F5EFDF',
  khaki: '#E8E1CB',
  loden: '#3B4E3A',
  lodenDark: '#2F3F2E',
  rust: '#B4501C',
  cream: '#EFE7D2',
  sage: '#9BAE93',
  display: 'Times-Bold',
  body: 'Helvetica',
  bodyBold: 'Helvetica-Bold',
  mono: 'Courier-Bold',
});
